import { render } from "./MetricUploadPage.vue?vue&type=template&id=073d25e2&scoped=true"
import script from "./MetricUploadPage.vue?vue&type=script&lang=js"
export * from "./MetricUploadPage.vue?vue&type=script&lang=js"

import "./MetricUploadPage.vue?vue&type=style&index=0&id=073d25e2&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073d25e2"]])

export default __exports__